// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rU90","expireSoon":"styles_expireSoon____Yja"};